module.exports = __webpack_public_path__ + "images/3.1792157180594.jpg";